<div class="align-input">
    <p-inputNumber [(ngModel)]="value" inputId="minmaxfraction" [maxFractionDigits]="maxFractionDigits" mode="decimal"
        [autofocus]="true" />
</div>